module.exports = __webpack_public_path__ + "img/product-7-INTzhuanye.4fa4c98c.png";